import React, { useLayoutEffect, useRef,  useEffect } from "react";
import AboutScrollSection from "../components/aboutscrollsection";
import GetInTouch from "../components/gettouch";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";



import icon01 from "../assets/image/Aboutus/Icons/SmartBuild.png"
import icon02 from "../assets/image/Aboutus/Icons/GlobalTech.png"
import icon03 from "../assets/image/Aboutus/Icons/Reliability.png"
import icon04 from "../assets/image/Aboutus/Icons/Totality.png"
import icon05 from "../assets/image/Aboutus/Icons/Quality.png"

import profile01 from "../assets/image/Aboutus/ourexperts/Akshay.png"
import profile02 from "../assets/image/Aboutus/ourexperts/Kartikeyan.png"
import profile03 from "../assets/image/Aboutus/ourexperts/Vishnu.png"
import profile04 from "../assets/image/Aboutus/ourexperts/Nevin.png"
import profile05 from "../assets/image/Aboutus/ourexperts/Gustavo.png"
import profile06 from "../assets/image/Aboutus/ourexperts/Edwin.png"


import midpage from "../assets/image/Aboutus/Midpage-large-image.png"

gsap.registerPlugin(ScrollTrigger);



const Members = [
  
  {
    name: "Akshaysundar S",
    position: "Co Founder and CEO",
    details: "Alumina of Edinburgh Business School & IIM Bangalore, handled India / SEA Markets",
    image: profile01,
  
  },
  {
    name: "Kartikeyan K",
    position: "Partner (Strategy & Business Build)",
    details: "Ex Director at MNC Corps, 25+ years in leadership roles, Ex — Intralox, 3M, Sandvik",
    image: profile02,
  
  },
 
 
];




const teamMembers = [

  {
    name: "Gustavo Riberio",
    position: "Founder, Arandu, Brazil",
    details: "30+ year experience in Poultry / Food Processing, implementation of poultry processing lines.",
    image: profile05,
   
  },
  {
    name: "Edwin Roman Rivera",
    position: "Food Safety Specialist",
    details: "18+ years experience in sanitation practices, hygienic design, food safety, and quality programs.",
    image: profile06,
  
  },
   {
    name: "Vishnu Puranik",
    position: "Founder (V-Align Automation | Packaging Automation & Capital Project Advisor)",
    details: "30+ years in packaging automation & FMCG capital projects | Packer-to-Palletizer domain expert",
    image: profile03,
   
  },
  {
    name: "Nevin Dadual",
    position: "Founder (Founder, ForceXtech, Chennai)",
    details: "23+ year experience in B2B sales — Food processing equipment, Industry 4, IOT",
    image: profile04,
  
  },
  
  
 
];


export default function About() {
  const heroRef = useRef();

  useLayoutEffect(() => {
    let ctx = gsap.context(() => {

      // ===============================
      // HERO HEADLINES INTRO ANIMATION
      // ===============================
      const tl = gsap.timeline({ defaults: { ease: "power4.out" } });

      tl.from(".is-a-wrap--1 .h1-s", { yPercent: 120, duration: 1 })
        .from(".is-a-wrap-2 .h1-ss", { yPercent: 120, duration: 1 }, "-=0.8")
        .from(".is-a-wrap-3 .h1-s", { yPercent: 120, duration: 1 }, "-=0.8")
        .from(".is-a-wrap-4 .h1-ss", { yPercent: 120, duration: 1 }, "-=0.8");

      // ===============================
      // SUBTEXT + IMAGE REVEAL
      // ===============================
      gsap.from(".text", {
        opacity: 0,
        y: 40,
        duration: 1,
        delay: 0.5
      });

      gsap.from(".ab-img-1", {
        scale: 1.3,
        yPercent: 20,
        duration: 2,
        ease: "power3.out"
      });

      // ===============================
      // SCROLL HEADING ROW PARALLAX
      // ===============================
      gsap.to(".is-row-6", {
        xPercent: 10,
        scrollTrigger: {
          trigger: ".is-row-6",
          start: "top bottom",
          scrub: true
        }
      });

      gsap.to(".is-row-4", {
        xPercent: -10,
        scrollTrigger: {
          trigger: ".is-row-4",
          start: "top bottom",
          scrub: true
        }
      });


      gsap.to(".is-a-wrap--1", {
  x: "10em",
  ease: "none",
  scrollTrigger: {
    trigger: ".hero-100",
    start: "top top",
    end: "bottom top",
    scrub: true
  }
});

gsap.to(".is-a-wrap-2", {
  x: "-6.7em",
  ease: "none",
  scrollTrigger: {
    trigger: ".hero-100",
    start: "top top",
    end: "bottom top",
    scrub: true
  }
});

gsap.to(".is-a-wrap-3", {
  x: "-11.7em",
  ease: "none",
  scrollTrigger: {
    trigger: ".hero-100",
    start: "top top",
    end: "bottom top",
    scrub: true
  }
});

gsap.to(".is-a-wrap-4", {
  x: "6.7em",
  ease: "none",
  scrollTrigger: {
    trigger: ".hero-100",
    start: "top top",
    end: "bottom top",
    scrub: true
  }});

      // ===============================
      // TEAM IMAGES POP IN
      // ===============================
      gsap.from(".sm-team-img-wrap", {
        scale: 0,
        y: 60,
        opacity: 0,
        stagger: 0.15,
        duration: 1,
        scrollTrigger: {
          trigger: ".is-sm-team-wrap",
          start: "top 80%"
        }
      });

      // ===============================
      // CERTIFICATE TEXT REVEAL
      // ===============================
      gsap.from(".cert-txt", {
        yPercent: 120,
        stagger: 0.1,
        duration: 0.8,
        scrollTrigger: {
          trigger: ".certificate-wrapper",
          start: "top 80%"
        }
      });

    }, heroRef);

    return () => ctx.revert();
  }, []);


 const sectionRef = useRef();

 useEffect(() => {
      const ctx = gsap.context(() => {
      gsap.to(".is-row-1", {
      xPercent: 5,
      ease: "none",
      scrollTrigger: {
      trigger: ".is-row-1",
      start: "top bottom",
      end: "bottom top",
      scrub: true
      }
      });

      gsap.to(".is-row-2", {
      xPercent: 5,
      ease: "none",
      scrollTrigger: {
      trigger: ".is-row-2",
      start: "top bottom",
      end: "bottom top",
      scrub: true
      }
      });

      gsap.to(".is-row-3", {
      xPercent: -8,
      ease: "none",
      scrollTrigger: {
      trigger: ".is-row-3",
      start: "top bottom",
      end: "bottom top",
      scrub: true
      }
      });

      gsap.to(".industry-img", {
      yPercent: -20,
      ease: "none",
      scrollTrigger: {
      trigger: ".industry-wrapper",
      start: "top bottom",
      end: "bottom top",
      scrub: true
      }
      });

      gsap.from(".h2-wrap", {
      y: 120,
      opacity: 0,
      duration: 1,
      stagger: 0.15,
      ease: "power3.out",
      scrollTrigger: {
      trigger: ".container-lg",
      start: "top 75%"
      }
      });

      gsap.from(".ind-wrapper", {
      y: 80,
      opacity: 0,
      duration: 1,
      stagger: 0.2,
      ease: "power3.out",
      scrollTrigger: {
      trigger: ".industry-wrapper",
      start: "top 70%"
      }
      });
 }, sectionRef);

 return () => ctx.revert(); // cleanup
 }, []);
  

  return (
    <div className="main-wrapper">
<section ref={heroRef} className="hero-100 is-aout-hero">
      <div className="container-lg is-serv-hero">
        <div className="flex-l-c">
          <div className="h1-s-wrap is-a-wrap--1">
            <h1 className="h1-s">BUILDING HYGIENIC SYSTEMS THAT </h1>
          </div>
          
        </div>

        <div className="flex-r-s">
          <div className="h1-s-wrap is-a-wrap-2">
            <h1 className="h1-ss"> POWER SAFER FOOD PRODUCTION</h1>
          </div>
        </div>

        {/* <div className="flex-l-c">
          <div className="h1-s-wrap is-a-wrap-3">
            <h1 className="h1-s">FOOD PRODUCTION</h1>
          </div>
        </div> */}

           
   <div className="container-lg is-sub-headline">
          <div className="d-60 is-about-mobile">
            <p className="text">
              Profit Through Process - When processes are right, profits follow.

              PthruP was founded to bring world-class hygienic engineering practices to India’s <strong>food processing</strong> industry, starting with poultry. What began with specialized foodsafe conveyance systems has grown into a complete solutions ecosystem.

              PthruP is building a portfolio of engineering services and technology to help poultry processors produce safe food, protect their brand, and increase throughput. Our FoodSafe-focused products and services — powered by global technology partnerships across India, France, Belgium, Brazil, USA, and Thailand — help you optimize your facility for safety and operational excellence.

              Today, we help processors design, build, and run safer, smarter, and more efficient plants across India and beyond.

            </p>
          </div>
          <div className="about-hero-img-wrapper">
            <div className="img-child">
              <div className="ab-img-1"></div>
            </div>
          </div>
        </div>
       
      </div>


         <div class="container-lg is-serv-hero is-mobile is-top-pad">
    <div class="flex-l-c">
        <div class="h1-s-wrap is-1">
            <h1 class="h1-s">BUILDING </h1>
        </div>
    </div>
    <div class="flex-l-c">
        <div class="h1-s-wrap">
            <h1 class="h1-s">HYGIENIC</h1>
        </div>
    </div>
    <div class="flex-r-s">
        <div class="h1-s-wrap is-right is-1">
            <h1 class="h1-ss">SYSTEMS THAT</h1>
        </div>
    </div>
    <div class="flex-r-s">
        <div class="h1-s-wrap is-right is-2">
            <h1 class="h1-ss">POWER SAFER</h1>
        </div>
    </div>
    <div class="flex-cc">
        <div class="h1-s-wrap is-1">
            <h1 class="h1-s">FOOD </h1>
        </div>
    </div>
    <div class="flex-cc">
        <div class="h1-s-wrap">
            <h1 class="h1-s">PRODUCTION</h1>
        </div>
    </div>
    {/* <div class="flex-l-s">
        <div class="h1-s-wrap is-right is-1">
            <h1 class="h1-ss is-3">Testing </h1>
        </div>
    </div>
    <div class="flex-l-s">
        <div class="h1-s-wrap is-right is-2">
            <h1 class="h1-ss is-3">Experts</h1>
        </div>
    </div> */}

     
</div>


    <div className="container-lg is-heading is-mobile">
          <div className="d-30 is-about-mobile">
            <p className="text">
              Profit Through Process - When processes are right, profits follow.

              PthruP was founded to bring world-class hygienic engineering practices to India’s <strong>food processing</strong> industry, starting with poultry. What began with specialized foodsafe conveyance systems has grown into a complete solutions ecosystem.

              PthruP is building a portfolio of engineering services and technology to help poultry processors produce safe food, protect their brand, and increase throughput. Our FoodSafe-focused products and services — powered by global technology partnerships across India, France, Belgium, Brazil, USA, and Thailand — help you optimize your facility for safety and operational excellence.

              Today, we help processors design, build, and run safer, smarter, and more efficient plants across India and beyond.

            </p>
          </div>
          <div className="about-hero-img-wrapper">
            <div className="img-child">
              <div className="ab-img-1"></div>
            </div>
          </div>
        </div>
     
      



<div class="container-lg is-heading is-mobile">
    <div class="d-25 is-ab-mobile">
        <p class="text"> PthruP delivers consulting-led engineering, foodsafe conveyance, and integrated processing solutions for modern poultry and protein plants.</p>
    </div>
    <div class="h-row is-mob-r-1">
        <div class="h2-wrap">
            <h2 class="h2-stroke">WE EMPOWER FOOD</h2>
        </div>
    </div>
    <div class="h-row is-mob-r-2">
        <div class="h2-wrap">
            <h2 class="h2"> PROCESSORS </h2>
        </div>
    </div>
    <div class="h-row is-no-move">
        <div class="h-row is-mob-r-3">
            <div class="h2-wrap">
                <h2 class="h2">WITH PRACTICAL</h2>
            </div>
        </div>
    
        <div class="h-row is-mob-r-4">
            <div class="h2-wrap">
                <h2 class="h2-stroke">, COMPLIANT, AND </h2>
            </div>
        </div>
    </div>
    <div class="h-row is-mob-r-5">
        <div class="h2-wrap">
            <h2 class="h2">HIGH-PERFORMING</h2>
        </div>
    </div>
    <div class="h-row is-mob-r-6">
        <div class="h2-wrap">
            <h2 class="h2">with</h2>
        </div>
        <div class="h2-wrap">
            <h2 class="h2-stroke"> SOLUTIONS </h2>
        </div>
    </div>
    <div class="h-row is-mob-r-7">
        <div class="h2-wrap">
            <h2 class="h2-stroke"> THAT -</h2>
        </div>
    </div>
    <div class="certificate-wrapper sub-headline-wrapper is-cert-red">
        <div class="h-divider"></div>
        <div class="flex-split-top is-cert">
            <div class="cert-txt-wrap">
                <div class="cert-txt"> food safety </div>
            </div>
            {/* <div class="v-line is-cert"></div> */}
            <div class="cert-txt-wrap">
                <div class="cert-txt">Reduce operational complexity</div>
            </div>
            {/* <div class="v-line is-cert"></div> */}
            <div class="cert-txt-wrap">
                <div class="cert-txt"> Increase productivity </div>
            </div>
            {/* <div class="v-line is-cert"></div> */}
            <div class="cert-txt-wrap">
                <div class="cert-txt">Enable long-term growth</div>
            </div>
        </div>
    </div>
</div>

      <div className="container-lg is-heading">
      <div className="d-25">
        <p className="text">
          PthruP delivers consulting-led engineering, foodsafe conveyance, and integrated processing solutions for modern poultry and protein plants.

        </p>
      </div>


      <div className="h-row is-row-6">
        <div className="h2-wrap">
          <h2 className="h2-stroke">WE EMPOWER FOOD </h2>
        </div>
        <div className="h2-wrap">
          <h2 className="h2">PROCESSORS </h2>
        </div>
      </div>

      <div className="h-row ">
        <div className="h2-wrap">
          <h2 className="h2">WITH PRACTICAL, </h2>
        </div>

        {/* <div className="flex-l-s is-sm-team-wrap">
          <div className="sm-team-img-wrap is-1">
            <div className="img-child">
              <div className="sm-team-img is-1"></div>
            </div>
          </div>

          <div className="sm-team-img-wrap is-2">
            <div className="img-child">
              <div className="sm-team-img is-2"></div>
            </div>
          </div>

          <div className="sm-team-img-wrap is-3">
            <div className="img-child">
              <div className="sm-team-img is-3"></div>
            </div>
          </div>

          <div className="sm-team-img-wrap is-4">
            <div className="img-child">
              <div className="sm-team-img is-4"></div>
            </div>
          </div>
        </div> */}

        <div className="h2-wrap">
          <h2 className="h2-stroke">COMPLIANT,</h2>
        </div>
        <div className="h2-wrap">
          <h2 className="h2">AND</h2>
        </div>
      </div>

      <div className="h-row is-row-c-2">
        <div className="h2-wrap">
          <h2 className="h2">HIGH-PERFORMING</h2>
        </div>
         <div className="h2-wrap">
          <h2 className="h2-stroke">SOLUTIONS THAT -</h2>
        </div>
      </div>

      {/* <div className="h-row is-row-4">
        <div className="h2-wrap">
          <h2 className="h2-stroke">SOLUTIONS THAT -</h2>
        </div>
      </div> */}
     
  <div className="certificate-wrapper sub-headline-wrapper is-cert-red">
        <div className="h-divider"></div>

        <div className="flex-split-top">
          <div className="cert-txt-wrap">
            <div className="cert-txt">Improve food safety</div>
          </div>

          <div className="v-line"></div>

          <div className="cert-txt-wrap">
            <div className="cert-txt">Reduce operational complexity</div>
          </div>

          <div className="v-line"></div>

          <div className="cert-txt-wrap">
            <div className="cert-txt">Increase productivity</div>
          </div>

          <div className="v-line"></div>

          <div className="cert-txt-wrap">
            <div className="cert-txt">Enable long-term growth
           </div>
          </div>
        </div>
      </div>
    </div>
   
    </section>

     <section className="section is-no-pad">
    <div className="banner-img is-a-1 is-about">
        <div className="img-child">
            <div className="banner-img-frame">
                <img src={ midpage} alt={ midpage}/>
              
            </div>
        </div>
    </div>
</section>

 <section className="section bg-black" ref={sectionRef}>
   
      <div className="container-lg is-heading">
        <div className="h-row is-row-1">
          <div className="h2-wrap">
            <h2 className="h2 txt-white">OVER THE</h2>
          </div>
          <div className="h2-wrap">
            <h2 className="h2-stroke is-black">PAST YEARS</h2>
          </div>
        </div>

        <div className="h-row is-row-2">
          <div className="h2-wrap">
            <h2 className="h2 txt-white">We have</h2>
          </div>
          <div className="h2-wrap">
            <h2 className="h2-stroke is-black">Expanded</h2>
          </div>
          <div className="h2-wrap">
            <h2 className="h2 txt-white">OUR EXPERTISE TO</h2>
          </div>
        </div>

        <div className="h-row is-row-3">
          <div className="h2-wrap">
            <h2 className="h2 txt-white">serve A</h2>
          </div>
          <div className="h2-wrap">
            <h2 className="h2-stroke is-black">Diverse Range</h2>
          </div>
          <div className="h2-wrap">
            <h2 className="h2 txt-white">of</h2>
          </div>
          <div className="h2-wrap">
            <h2 className="h2-stroke is-black">CUSTOMERS</h2>
          </div>
        </div>
      </div>

      {/* MOBILE HEADING */}
      <div className="container-lg is-heading is-mobile">
        <div className="h-row is-mob-r-1">
          <div className="h2-wrap"><h2 className="h2 txt-white">over the</h2></div>
          <div className="h2-wrap"><h2 className="h2-stroke is-black">Past</h2></div>
        </div>

        <div className="h-row is-mob-r-2">
          <div className="h2-wrap"><h2 className="h2-stroke is-black">decade</h2></div>
          <div className="h2-wrap"><h2 className="h2 txt-white">We have</h2></div>
        </div>

        <div className="h-row is-mob-r-3">
          <div className="h2-wrap"><h2 className="h2-stroke is-black">Expanded</h2></div>
          <div className="h2-wrap"><h2 className="h2 txt-white">Our</h2></div>
        </div>

        <div className="h-row is-mob-r-4">
          <div className="h2-wrap">
            <h2 className="h2 txt-white">services to serve A</h2>
          </div>
        </div>

        <div className="h-row is-mob-r-6">
          <div className="h2-wrap"><h2 className="h2-stroke is-black">Diverse Range</h2></div>
          <div className="h2-wrap"><h2 className="h2 txt-white">of</h2></div>
        </div>

        <div className="h-row is-mob-r-7">
          <div className="h2-wrap"><h2 className="h2-stroke is-black">industries</h2></div>
        </div>
      </div>

      {/* INDUSTRY LIST */}
      <div className="industry-wrapper">
        <div className="ind-list-wrapper">
          {/* <div className="ind-text-wrapper">
            <div className="d-50">
              <p className="text txt-white">
                We identify defects, prevent failures, and maintain compliances
                with international safety and quality standards without
                compromising structural integrity.
              </p>
            </div>
          </div> */}

          <div className="flex-r-v is-industry-wrapper">

            {[
              "Consulting-Led Process Design",
              "Hygienic Conveyance Systems",
              "Integrated Equipment Solutions",
              "Plant Execution & Integration",
              "Operational Support",
            ].map((industry, i) => (
              <React.Fragment key={i}>
                <div className={`ind-wrapper is-${i + 1}`}>
                  <div className="ind-txt-wrapper">
                    <div className="industry-txt">{industry}</div>
                  </div>

                  <div className={`industry-img-wrapper is-${i + 1}`}>
                    <div className="img-child is-center">
                      <div className={`industry-img is-${i + 1}`}></div>
                    </div>
                  </div>
                </div>

                {i !== 5 && <div className={`h-line-white is-l-${i + 1}`} />}
              </React.Fragment>
            ))}

          </div>
        </div>
      </div>
    </section>
      <AboutScrollSection/>

      <section className="section">

      {/* ===== HEADING DESKTOP ===== */}
      <div className="flex-split-top is-r-padded">
        <div className="container-lg is-heading">

          <div className="h-row is-row-1">
            <div className="h2-wrap"><h2 className="h2">Our</h2></div>
            <div className="h2-wrap"><h2 className="h2-stroke">Success</h2></div>
            <div className="h2-wrap"><h2 className="h2">is driven by A Team</h2></div>
          </div>

          <div className="h-row is-row-2 is-special">
            <div className="h2-wrap"><h2 className="h2">of Highly</h2></div>
            <div className="h2-wrap is-special">
              <h2 className="h2-stroke">Qualified Experts</h2>
            </div>
          </div>
{/* 
          <div className="h-row-no-move">
            <div className="h-row is-row-4 is-below-special">
              <div className="h2-wrap">
                <h2 className="h2-stroke">Experts</h2>
              </div>
            </div>
          </div> */}

        </div>
      </div>


      
      {/* ===== TEAM GRID ===== */}
      <div className="flex-split-btm is-team-wrapper">
        <div className="collection-list-wrapper w-dyn-list">
           <div role="list" className="team-name-list w-dyn-items">
    <div className="h-row is-row-1 d-100 text is-center">
            <div className="h2-wrap"><h2 className="h2">Management Team</h2></div>
          </div>

      <div className="flex-split-btm is-team-wrapper">
   {Members.map((member, index) => (



                <div role="listitem" key={index} className="collection-item-2 w-dyn-item">
                    <div className="team-card">
                        <div data-w-id="f12393fc-d62d-7cb2-75b8-d74a1701d898" className="team-img-wrap">
                            <div className="img-child is-center">
                                <div  style={{ backgroundImage: `url(${member.image})` }} className="team-img"></div>
                                <div className="inner-rect">
                                </div>
                            </div>
                        </div>
                        <div className="flex-v-c">
                            <div className="t-name-wrap">
                                <div className="t-name-text">{member.name}</div>
                            </div>
                            <div className="pos-text is-bold"> {member.position}</div>
                               <div className="pos-text is-certificate w-richtext"><p className="text is-center">{member.details}</p></div>
                            
                         
                        </div>
                    </div>
                </div>
            
          ))}
      </div>
           


          
           </div>

        </div>
      </div>

      {/* ===== TEAM GRID ===== */}
      <div className="flex-split-btm is-team-wrapper">
        <div className="collection-list-wrapper w-dyn-list">
           <div role="list" className="team-name-list w-dyn-items">
<div className="h-row is-row-1 d-100 text is-center">
            <div className="h2-wrap"><h2 className="h2-stroke">Advisory Board</h2></div>
          </div>
       <div className="flex-split-btm is-team-wrapper">
        
   {teamMembers.map((member, index) => (



                <div role="listitem" key={index} className="collection-item-2 w-dyn-item">
                    <div className="team-card">
                        <div data-w-id="f12393fc-d62d-7cb2-75b8-d74a1701d898" className="team-img-wrap">
                            <div className="img-child is-center">
                                <div  style={{ backgroundImage: `url(${member.image})` }} className="team-img"></div>
                                <div className="inner-rect">
                                </div>
                            </div>
                        </div>
                        <div className="flex-v-c">
                            <div className="t-name-wrap">
                                <div className="t-name-text">{member.name}</div>
                            </div>
                            <div className="pos-text is-bold"> {member.position}</div>
                             <div className="pos-text is-certificate w-richtext"><p className="text is-center">{member.details}</p></div>
                        </div>
                    </div>
                </div>
            
          ))}
       </div>
           


          
           </div>

        </div>
      </div>

    </section>

    <section className="section top-btm-padded is-faq">
    <div className="container-lg is-heading">
        <div className="h-row is-row-1">
            <div className="h2-wrap">
                <h2 className="h2">Why Our Clients</h2>
            </div>
            <div className="h2-wrap">
                <h2 className="h2-stroke">Choose us</h2>
            </div>
        </div>
        <div className="h-row is-row-2">
            <div className="h2-wrap">
                <h2 className="h2">As their</h2>
            </div>
            <div className="h2-wrap">
                <h2 className="h2-stroke">trusted PARTNER?</h2>
            </div>
        </div>
    </div>
    <div className="container-lg is-heading is-mobile">
        <div className="h-row is-mob-r-1">
            <div className="h2-wrap">
                <h2 className="h2">Why Our Clients</h2>
            </div>
        </div>
        <div className="h-row is-mob-r-2">
            <div className="h2-wrap">
                <h2 className="h2-stroke">Choose us</h2>
            </div>
            <div className="h2-wrap">
                <h2 className="h2">As their</h2>
            </div>
        </div>
        <div className="h-row is-mob-r-3">
            <div className="h2-wrap">
                <h2 className="h2-stroke">trusted </h2>
            </div>
        </div>
        <div className="h-row is-mob-r-4">
            <div className="h2-wrap">
                <h2 className="h2-stroke">PARTNER?</h2>
            </div>
        </div>
    </div>
    <div className="container-lg is-pad">
        <div className="quick-stack-wrapper is-wcu">
            <div className="flex-row">
                <div className="para-wrap is-wcu">
                    <p className="text">PthruP delivers consulting-led engineering, foodsafe conveyance, and integrated processing solutions for modern poultry and protein plants.</p>
                </div>
                <div className="wcu-card">
                    <div className="wcu-icon-frame">
                        <div className="icon-wrapper">
                            <div className="wcu-lottie"><img className="img-responsive" src={icon01} alt={icon01}/></div>
                        </div>
                        <div className="whipe-black is-c-2"></div>
                    </div>
                    <div className="wcu-content-wrap">
                        <div className="wcu-card-title">SmartBuild</div>
                        <div className="para-wrap is-wcu-card">
                            <p className="text">Built for hygiene, efficiency, and long-term value. Every system is engineered to perform under the most demanding processing environments.
</p>
                        </div>
                    </div>
                </div>
                <div className="wcu-card">
                    <div className="wcu-icon-frame">
                        <div className="icon-wrapper">
                            <div className="wcu-lottie"><img className="img-responsive" src={icon02} alt={icon02}/></div>
                        </div>
                        <div className="whipe-black is-c-1"></div>
                    </div>
                    <div className="wcu-content-wrap">
                        <div className="wcu-card-title">GlobalTech</div>
                        <div className="para-wrap is-wcu-card">
                            <p className="text">Backed by world-class technology and partners across 6 countries, bringing global best practices to every project</p>
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex-row">
                
                <div className="wcu-card">
                    <div className="wcu-icon-frame">
                        <div className="icon-wrapper">
                            <div className="wcu-lottie"><img className="img-responsive" src={icon03} alt={icon03}/></div>
                        </div>
                        <div className="whipe-black is-c-2"></div>
                    </div>
                    <div className="wcu-content-wrap">
                        <div className="wcu-card-title">Reliability</div>
                        <div className="para-wrap is-wcu-card">
                            <p className="text">Strong after-sales and integration support. We don't just deliver — we stay.</p>
                        </div>
                    </div>
                </div>
                <div className="wcu-card">
                    <div className="wcu-icon-frame">
                        <div className="icon-wrapper">
                            <div className="wcu-lottie"><img className="img-responsive" src={icon04} alt={icon04}/></div>
                        </div>
                        <div className="whipe-black is-c-3"></div>
                    </div>
                    <div className="wcu-content-wrap">
                        <div className="wcu-card-title">Totality</div>
                        <div className="para-wrap is-wcu-card">
                            <p className="text">One-stop solution provider for poultry processing. Design, infrastructure, maintenance, and continuous improvement under one roof.</p>
                        </div>
                    </div>
                </div>
                 <div className="wcu-card">
                    <div className="wcu-icon-frame">
                        <div className="icon-wrapper">
                            <div className="wcu-lottie"><img className="img-responsive" src={icon05} alt={icon05}/></div>
                        </div>
                        <div className="whipe-black is-c-4"></div>
                    </div>
                    <div className="wcu-content-wrap">
                        <div className="wcu-card-title">Quality</div>
                        <div className="para-wrap is-wcu-card">
                            <p className="text">Custom-built solutions with optimized costs and global standards. No compromises.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
 
</section>
   <GetInTouch/>
    </div>
    
  );
}

